<template>
  <div style="text-align: left">
    <div id="map" :style="isMobile ? 'height: 55vh;' : 'height: 70vh;'"></div>
  </div>
</template>

<style>
#map {
  width: 100%;
  z-index: 1;
}
.mapboxgl-marker {
  z-index: 5;
}
</style>

<script>
import Mapbox from 'mapbox-gl'

export default {
  mounted () {
    this.initMap()
  },
  data: () => ({
    map: null,
    accessToken: 'pk.eyJ1IjoianVhbmJ1ZW5vIiwiYSI6ImNrNXNtbmc4bjBua3YzZW11MnNoYXVrcDYifQ.CBUTZiyPC4ubfGXL0uh6VQ', // your access token. Needed if you using Mapbox maps
    mapStyle: 'mapbox://styles/mapbox/satellite-v9', // your map style
    madrid: [-3.703790, 40.416775]
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
    farms () {
      return this.$store.state.farms.wind_farms
    },
    center () {
      const madrid = this.madrid
      // const element = this.$store.state.dashboard.farms[0] || {}
      // const substation_coordinates = element.substation_coordinates
      // let coordinates = null
      // if (substation_coordinates) {
      //   coordinates = substation_coordinates.split(',').map(e => Number(e))
      // }
      return madrid
    },
  },
  watch: {
    farms () {
      this.loadMarkers()
    }
  },
  methods: {
    async initMap () {
      Mapbox.accessToken = this.accessToken
      if (!this.map) {
        this.map = new Mapbox.Map ({
          container: 'map',
          style: this.mapStyle,
          center: this.center,
          zoom: 4
        })
        // Add geolocate control to the map.
        this.map.addControl(
          new Mapbox.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
            },
            trackUserLocation: true
          }), 'bottom-left'
        )
      }
      this.loadMarkers()
    },
    goToLocation (location) {
      this.map.jumpTo({
        center: location,
        zoom: 16,
        speed: 1
      })
    },
    flyToLocation (location) {
      this.map.flyTo({
        center: location,
        zoom: 16,
        speed: 1
      })
    },
    loadMarkers () {
      const markers = []
      for (let i=0; i < this.farms.length; i++) {
        const element = this.farms[i]
        const substation_coordinates = element.substation_coordinates
        let coordinates = null
        if (substation_coordinates) {
          coordinates = substation_coordinates.split(',').map(e => Number(e)).reverse()

          // Create DOM element for the marker
          let el = document.createElement('div')
          el.id = 'marker' + i
          el.innerHTML = '<i aria-hidden="true" class="v-icon notranslate mdi mdi-map-marker theme--light primary--text" style="font-size: 60px;"></i>'
          markers.push(coordinates)
          // Create the popup
          const popup = new Mapbox.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: 25
          })
          // Mouseover
          el.addEventListener('mouseover', () => {
            el.style.cursor = 'pointer'
            popup
            .setLngLat(coordinates)
            .setHTML('<h3>' + element.name + '</h3>')
            .addTo(this.map)
          })
          // Mouseleave
          el.addEventListener('mouseleave', () => {
            el.style.cursor = ''
            popup.remove()
          })
          // Click
          el.addEventListener('click', () => {
            this.flyToLocation(coordinates)
          })
          // Create the marker
          new Mapbox.Marker(el)
            .setLngLat(coordinates)
            .addTo(this.map)
        }
        markers.length > 1
          ? this.map.fitBounds(markers, { adding: 50 })
          : this.map.flyTo({ center: markers[0] })
      }
    },
  }
}
</script>
